import React, { FunctionComponent, MouseEvent } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Image from 'material-ui-image';
import cardHeaderStyles from './cardHeaderStyles';
import CarUnavailable from '../../../../../common/assets/images/carUnavailable.png';
import Translation from '../../../../../common/components/translation/Translation';
import { ICarStockMatch } from '../../../../../common/model/ICarStockMatch';
import clsx from 'clsx';
import CarPrices from '../../../../../gqlProductCatalog/components/car/CarPricesContainer';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import {
  GetCustomizeCar_customizeCar_similarStockCars_prices_totalPrice,
  GetCustomizeCar_customizeCar_similarStockCars_finance,
} from '../../../../graphql/queries/__generated__/GetCustomizeCar';
import usePrice from '../../../../../gqlCommon/hooks/prices/usePrice';
import { StockTypes } from '../../../../../common/enum/StockTypes';

export interface ICardHeaderProps {
  carImageSource: string;
  alt: string;
  title: string;
  prices: GetCustomizeCar_customizeCar_similarStockCars_prices_totalPrice[];
  onClick: (event?: MouseEvent<HTMLDivElement>) => void;
  stockMatch?: ICarStockMatch;
  stockType?: StockTypes;
  carMatchLabel?: string;
  finance: GetCustomizeCar_customizeCar_similarStockCars_finance;
  hasDisclaimer: boolean;
}

const CardHeader: FunctionComponent<ICardHeaderProps> = ({
  carImageSource,
  alt,
  title,
  prices,
  onClick,
  stockMatch,
  stockType,
  finance,
  carMatchLabel,
  hasDisclaimer,
}) => {
  const styles = cardHeaderStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const { primaryPrice, secondaryPrice } = usePrice(prices);

  return (
    <Box className={styles.container}>
      <Box className={styles.cornerContainer} data-test={`stockLite:header:label:${stockMatch}`}>
        <Box
          className={clsx([
            styles.cornerLabel,
            {
              [styles.exactLabel]: stockMatch !== ICarStockMatch.NEAR,
            },
          ])}
        >
          <Typography variant="caption" className={styles.label} data-test="stock:car_card:label">
            <Translation id={carMatchLabel} />
          </Typography>
        </Box>
      </Box>
      <Typography variant="h4" className={styles.title} data-test="stock:car_card:title">
        {title}
      </Typography>
      <Box className={styles.imageContainer}>
        <Image
          src={carImageSource ?? CarUnavailable}
          className={styles.image}
          color="transparent"
          animationDuration={0}
          aspectRatio={1.4}
          data-test="stockLite:carCard:carImage"
          alt={alt}
          onClick={onClick}
        />
      </Box>
      <Box p={2} className={styles.pricing}>
        <CarPrices
          primary={primaryPrice.money.amount}
          secondary={secondaryPrice?.money.amount}
          priceDisplay={priceDisplay}
          initialFinance={finance}
          stockMatch={stockMatch}
          stockType={stockType}
          hasDisclaimer={hasDisclaimer}
        />
      </Box>
    </Box>
  );
};

export default CardHeader;
